export default function LogoBackgroundSilhouette() {
  return (
    <svg fill="none" viewBox="0 0 828 368" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M364.064 230.483c3.886-14.848 5.954-30.425 5.954-46.483 0-101.62-82.831-184-185.009-184C82.832 0 0 82.38 0 184s82.832 184 185.009 184c15.882 0 31.296-1.99 46.004-5.734h580.974c8.844 0 16.013-7.169 16.013-16.013 0-8.843-7.169-16.013-16.013-16.013H297.306a186.106 186.106 0 005.543-4.385h356.993a7.948 7.948 0 000-15.895H319.873a185.362 185.362 0 007.087-7.948h106.314c10.973 0 19.869-8.896 19.869-19.869 0-10.974-8.896-19.87-19.869-19.87h-80.782a182.157 182.157 0 006.624-15.895h157.628a7.947 7.947 0 100-15.895h-152.68z"
        fill="url(#paint0_linear_177_155)"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M18.718 174.849c-.732-9.089 1.007-34.258 13.725-59.111 11.072-21.635 26.283-42.063 36.651-54.196l34.32 23.58L86.78 174.85H18.718zM81.684 49.261l27.54 18.922 27.937-47.416.38.224-.398-.235 2.592-2.31c-2.55.722-4.827 1.575-6.679 2.58-2.702 1.467-6.379 3.437-10.555 5.675-13.907 7.45-33.352 17.868-40.817 22.56zm43.196 26.337l27.136-46.054.014.008c6.061-7.778 10.641-11.493 17.144-14.738 2.665-.07 5.082-.078 7.094-.045v71.749l-51.388-10.92zm229.212 115.146c-4.071 44.935-12.287 68.299-41.84 103.324-3.775 4.181-7.443 8.06-11.058 11.657l-13.561-9.145-16.997-11.679 16.607-94.157h66.849zM206.428 347.327c-4.535.351-9.281.617-14.261.807v-67.278l55.058 10.7-35.805 49.267.015.012-5.007 6.492zm27.828-3.79c21.079-4.443 37.294-12.32 53.301-25.412l-23.232-15.963-30.069 41.375zm-42.089-152.793h74.696l-15.003 85.059-59.693-11.6v-73.459zm0-190.744c2.736.056 5.457.17 8.163.34-2.68-.142-5.401-.254-8.163-.335V0zm0 88.026v-72.72c15.591 5.261 20.723 9.132 27.899 17.129l.283-.18 27.941 43.846-56.123 11.925zm160.017 7.093c-.306-.549-.616-1.096-.929-1.64.288.543.576 1.09.862 1.64h.067zm-68.931 79.73h70.623c-3.593-51.146-16.257-75.172-50.105-112.247l-1.525 1.047.235.348L272.15 84.45l11.103 90.399zm8.387-125.138l.074.078-25.261 17.034-27.506-43.162 52.693 26.05zm-28.608 125.138l-10.258-83.526-.389-.576.243 1.144-60.461 12.848v70.11h70.865zm-142.084-87.1l.139-.202-.047.22-.092-.018zm-14.791 87.1h70.111v-70.956L121.47 92.249l-15.313 82.6zm-25.401 15.895H17.742c2.796 32.739 9.397 51.791 30.16 85.738 8.917 11.176 17.207 20.509 25.151 28.326l29.382-20.188-.107-.463-.008-.013.004-.002-21.568-93.398zm57.002 151.214c-18.147-4.162-34.156-11.289-51.066-24.924l25.182-17.303 25.884 42.227zm38.51 5.297a551.745 551.745 0 01-9.602-.863l-8.354-9.172-.002.002-28.142-45.911 46.1-9.796v65.74zm-53.213-71.53l53.213-11.308v-73.673H103.43l19.625 84.981z"
        fill="#000"
        fillRule="evenodd"
      />
      <ellipse
        cx="145.499"
        cy="91.556"
        fill="#fff"
        fillOpacity=".20"
        rx="82.631"
        ry="104.385"
        transform="rotate(56.5 145.499 91.556)"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_177_155"
          x1={414}
          x2={414}
          y1={0}
          y2={368}
        >
          <stop stopColor="#fff" stopOpacity={0} />
          <stop offset=".734" />
        </linearGradient>
      </defs>
    </svg>
  );
}
